module.exports = __webpack_public_path__ + "img/14_life_below_water_color.5b3d2af8.svg";